import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { HisOption } from '../model/his-option';
import { HisSelectOptions } from '../model/his-select-options';

@Injectable({providedIn: 'root'})
export class HisSearchSelectfromService {

    private cache: Map<string, HisSelectOptions>;

    constructor() {
        this.cache = new Map();
    }

    // TODO Since addEntry() is never used, there is no write access to the cache...
    private addEntry( k: string, v: number, opts: HisOption[] ): void {
        let versioned: HisSelectOptions = { vkey: { version: v, key: k }, options: opts };
        this.cache.set( k, versioned );
    }

    public getKnownSelectfromLists( keys: string[] ): Observable<Map<string, HisSelectOptions>> {
        let m = new Map();
        for ( let k of keys ) {
            let o = this.cache.get( k );
            if ( !o ) {
                // insert dummy options with version "-1" for each key that is requested but not registered in the cache
                o = { vkey: { key: k, version: -1 }, options: null };
            }
            m.set( k, o );
        }
        return of( m );
    }
}
